import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, takeUntil, filter } from 'rxjs/operators';
import { delay, noop, Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {
  BASE_ROLES,
  BaseApplication,
  BaseCoreState,
  BaseModalService,
  BaseRolesService,
  baseSharedSelectors,
} from 'base';
import { BaseCustomerOnboardingService } from '../../onboarding/_services/onboarding.service';

@Component({
  selector: 'base-customer-login-form',
  templateUrl: './login-form.component.html',
})
export class BaseCustomerLoginFormComponent implements OnInit, OnDestroy {
  @ViewChild('baseOnboardingLight', { static: true }) baseOnboardingLight: ElementRef;
  logo: string;
  application: BaseApplication;
  showOnboardingModal = false;
  modalRef: NgbModalRef;
  loadAPI: Promise<any>;
  private destroy$ = new Subject();

  constructor(
    private store: Store<BaseCoreState>,
    private route: ActivatedRoute,
    private baseModalService: BaseModalService,
    private baseRolesService: BaseRolesService,
    private baseCustomerOnboardingService: BaseCustomerOnboardingService
  ) {
    this.application = this.route.snapshot.data?.application as BaseApplication;
    this.logo = this.route.snapshot.data?.logo as string;
  }

  ngOnInit() {
    this.store
      .select(baseSharedSelectors.getProfile)
      .pipe(
        takeUntil(this.destroy$ || this.showOnboardingModal),
        filter((user) => !!user.data),
        map((user) => user.data),
        delay(2500)
      )
      .subscribe((userData) => {
        if (!this.baseRolesService.hasRole(BASE_ROLES.CUSTOMER_ADMIN) || !userData?.onboardingRequired) {
          return;
        }

        if (!this.showOnboardingModal) {
          this.callOnboardingModal();
          this.loadAPI = new Promise((resolve) => {
            this.baseCustomerOnboardingService.loadScript();
            resolve(true);
          });
          this.showOnboardingModal = true;
          this.destroy$.next(true);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  private callOnboardingModal() {
    this.modalRef = this.baseModalService.open(
      {
        bodyTemplate: this.baseOnboardingLight,
        cancelText: 'action.close',
        okButtonDisplayed: false,
        hideHeader: true,
      },
      {
        backdrop: 'static',
        size: 'lg',
      }
    );

    this.modalRef.result.then(noop, noop);
  }
}
